import { Info } from "@mui/icons-material";
import { Box, Paper, styled, Tooltip, Typography } from "@mui/material";
import { StyledMarkdown } from "components/utils/StyledMarkdown";
import { round } from "lodash-es";
import { useTranslation } from "react-i18next";
import { MappedAdaptationIndicatorValue } from "types/types";

interface Props {
  mappedAdaptationIndicatorValue: MappedAdaptationIndicatorValue;
}
export default function DetailItem(props: Props) {
  const { mappedAdaptationIndicatorValue } = props;
  const { t } = useTranslation();

  const roundedValue = round(
    mappedAdaptationIndicatorValue.value,
    2
  ).toLocaleString("nl-BE");

  return (
    <StyledPaper className="detail-item">
      {mappedAdaptationIndicatorValue.description && (
        <Box className="info-box">
          <Tooltip
            title={
              <Box className="tooltip-box">
                <StyledMarkdown
                  content={mappedAdaptationIndicatorValue.description}
                />
                <Typography>{t("label.numberInRedExplanation")}</Typography>
              </Box>
            }
          >
            <Info color="primary" />
          </Tooltip>
        </Box>
      )}

      <div className="value-section">
        <Typography variant="h1" component="p">
          {roundedValue}
          {mappedAdaptationIndicatorValue.unit}
        </Typography>
        {mappedAdaptationIndicatorValue.difference !== 0 && (
          <Typography variant="h3" color="error" component="p">
            {mappedAdaptationIndicatorValue.difference > 0 ? "+" : ""}
            {round(mappedAdaptationIndicatorValue.difference, 2).toLocaleString(
              "nl-BE"
            )}
            {mappedAdaptationIndicatorValue.unit}
          </Typography>
        )}
      </div>
      {mappedAdaptationIndicatorValue.name}
    </StyledPaper>
  );
}

const StyledPaper = styled(Paper)`
  position: relative;
  padding: ${({ theme }) => theme.spacing(6)};
  padding-top: ${({ theme }) => theme.spacing(4)};
  padding-bottom: ${({ theme }) => theme.spacing(4)};
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1)};
  width: ${({ theme }) => theme.spacing(31)};
  .value-section {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    gap: ${({ theme }) => theme.spacing(1)};
  }
  .info-box {
    position: absolute;
    top: ${({ theme }) => theme.spacing(1)};
    right: ${({ theme }) => theme.spacing(1)};
  }
`;
